import React from "react";

export const bdtFmt = new Intl.NumberFormat("en-BD", {
  style: "currency",
  currency: "BDT",
  minimumFractionDigits: 2,
});

const shareFmt = new Intl.NumberFormat("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatShareQty(n) {
  return shareFmt.format(Number(n || 0));
}

export function DetailValue({ children, empty }) {
  if (empty) {
    return <span className="investor-offer-detail__empty">Not yet</span>;
  }
  return <span className="investor-offer-detail__value">{children}</span>;
}

export function DetailRow({ label, children, empty }) {
  return (
    <div className="investor-offer-detail__row">
      <span className="investor-offer-detail__label">{label}</span>
      <DetailValue empty={empty}>{children}</DetailValue>
    </div>
  );
}
